export const DASHBOARD_ROUTE = '/dashboard';
export const METER_ROUTE = '/meter';
export const PAYMENT_ROUTE = '/payment/';
export const PROPERTY_ROUTE = '/property';
export const RECEIPT_ROUTE = '/accounting/receipts';
export const UTILITY_BILLING_ROUTE = '/utility-billing/';
export const TENANT_ROUTE = '/user/';
export const PARTNER_ROUTE = '/partner';
export const RENT_INCOME_CONTROL = '/user/rentIncomeTracking';
